export enum LeadStatusEnum {
  NEW = 'NEW',

  UNREACHABLE = 'UNREACHABLE',
  REACHED = 'REACHED',

  NOT_RELEVANT = 'NOT_RELEVANT',
  INTERESTED = 'INTERESTED',
  NOT_INTERESTED = 'NOT_INTERESTED',

  PRICE_SENSITIVE = 'PRICE_SENSITIVE',
  CHOSE_COMPETITOR = 'CHOSE_COMPETITOR',

  CONVERTED = 'CONVERTED',
  LOST = 'LOST',

}

export const LeadStatusEnumValues: LeadStatusEnum[] = [
  LeadStatusEnum.NEW,

  LeadStatusEnum.UNREACHABLE,
  LeadStatusEnum.REACHED,

  LeadStatusEnum.INTERESTED,
  LeadStatusEnum.NOT_INTERESTED,
  LeadStatusEnum.PRICE_SENSITIVE,
  LeadStatusEnum.CHOSE_COMPETITOR,

  LeadStatusEnum.NOT_RELEVANT,

  LeadStatusEnum.CONVERTED,
  LeadStatusEnum.LOST,
];